import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import JourneyStrip from './JourneyStrip';

const journeySteps = [
  { id: 'discover', label: 'Discover' },
  { id: 'reserve', label: 'Reserve' },
  { id: 'confirmed', label: 'Confirmed' },
];

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-onyx grain flex flex-col items-center justify-center p-6 relative overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full blur-3xl opacity-[0.15]"
        style={{ background: 'radial-gradient(circle, #EC8AAE 0%, transparent 60%)' }}
      />
      <div className="relative w-full max-w-xl">
        <div className="mb-8">
          <JourneyStrip steps={journeySteps} currentStep="reserve" tone="paused" />
        </div>
        <div className="bg-carbon border border-pewter/70 p-10 md:p-14 text-center">
        <p className="eyebrow mb-4">No charges</p>
        <h1 className="font-serif text-ivory text-3xl md:text-4xl mb-4">
          Your reservation was <span className="brand-italic chrome-rose">cancelled.</span>
        </h1>
        <p className="text-silverx text-sm leading-relaxed mb-10 max-w-md mx-auto">
          No payment has been processed. Your ritual is waiting whenever you're ready.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => navigate('/#booking')}
            className="btn-pill flex-1 inline-flex justify-center items-center gap-2 px-6 py-4 rounded-full bg-ivory text-onyx text-[11px] tracking-[0.28em] uppercase font-medium hover:bg-blush"
          >
            Try Booking Again <ArrowUpRight size={13} />
          </button>
          <button
            onClick={() => navigate('/')}
            className="btn-pill flex-1 inline-flex justify-center items-center gap-2 px-6 py-4 rounded-full border border-pewter text-ivory text-[11px] tracking-[0.26em] uppercase hover:border-blush hover:text-blush"
          >
            Return Home
          </button>
        </div>

        <p className="text-silverx text-[11px] tracking-[0.2em] uppercase mt-10">
          Questions?{' '}
          <a href="mailto:support@snatchedbeauties.com" className="text-ivory hover:text-blush">
            support@snatchedbeauties.com
          </a>
          {' · '}
          <a href="tel:323-613-5153" className="text-ivory hover:text-blush">323-613-5153</a>
        </p>
      </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
